import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-todo104",
  "use": "icon-icon-todo104-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-todo104\"><path d=\"M1024 512a172.8 172.8 0 0 0-69.12-128A172.8 172.8 0 0 0 1024 256c0-141.44-229.12-256-512-256S0 114.56 0 256a172.8 172.8 0 0 0 69.12 128A172.8 172.8 0 0 0 0 512a172.8 172.8 0 0 0 69.12 128A172.8 172.8 0 0 0 0 768c0 141.44 229.12 256 512 256s512-114.56 512-256a172.8 172.8 0 0 0-69.12-128A172.8 172.8 0 0 0 1024 512z m-128 0c0 32-136.32 128-384 128S128 544 128 512c0-12.16 21.76-34.56 64-56.96A885.76 885.76 0 0 0 512 512a885.76 885.76 0 0 0 320-56.96c42.24 22.4 64 44.8 64 56.96zM512 128c247.68 0 384 96 384 128s-136.32 128-384 128-384-96-384-128 136.32-128 384-128z m0 768c-247.68 0-384-96-384-128 0-12.16 21.76-34.56 64-56.96A885.76 885.76 0 0 0 512 768a885.76 885.76 0 0 0 320-56.96c39.68 22.4 64 44.8 64 56.96 0 32-136.32 128-384 128z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/icon-todo104.svg
// module id = gYfG
// module chunks = 3